var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"foot-body",attrs:{"id":"foot-body","type":"flex","justify":"space-between"}},_vm._l((_vm.cards),function(card,index){return _c('company-card',{key:index,attrs:{"card":card,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }